export const fmtMoney = (v) => {
  if (v === null || v === undefined) return "-";
  if (v >= 1_000_000) return `€${(v / 1_000_000).toFixed(v % 1_000_000 === 0 ? 0 : 1)}m`;
  if (v >= 1_000) return `€${Math.round(v / 1000)}k`;
  return `€${v}`;
};

export const fmtWage = (v) => {
  if (!v) return "-";
  if (v >= 1_000_000) return `€${(v / 1_000_000).toFixed(1)}m/wk`;
  return `€${Math.round(v / 1000)}k/wk`;
};

const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const matchTime = (utc) => {
  if (!utc) return "";
  const d = new Date(utc);
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};

export const matchDate = (utc) => {
  if (!utc) return "";
  const d = new Date(utc);
  return `${DAYS[d.getDay()]} ${d.getDate()} ${MONTHS[d.getMonth()]}`;
};

export const dateKey = (utc) => {
  if (!utc) return "";
  const d = new Date(utc);
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${m}-${day}`;
};

export const isLive = (s) => ["IN_PLAY", "PAUSED", "LIVE"].includes(s);
export const isFinished = (s) => s === "FINISHED";
const OFF_LABEL = { POSTPONED: "PPD", CANCELLED: "CANC", ABANDONED: "ABD", SUSPENDED: "SUSP" };
export const isCalledOff = (s) => !!OFF_LABEL[s];
// Still to be played: scheduled, not called off, and kickoff not long past (stale feed guard)
export const isUpcoming = (m) =>
  ["TIMED", "SCHEDULED"].includes(m.status) && new Date(m.utcDate) > Date.now() - 3 * 3600e3;

// Live games first, furthest-along minute on top; everything else keeps its order.
const liveMinute = (m) => (m.status === "PAUSED" ? 45.5 : m.elapsed || 0);
export const sortLiveByMinute = (list) =>
  [...list].sort((a, b) => {
    const la = isLive(a.status), lb = isLive(b.status);
    if (la && lb) return liveMinute(b) - liveMinute(a);
    return la === lb ? 0 : la ? -1 : 1;
  });

const LONG_MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

// "October 20, 2026" or "October 18 - 20, 2026" (spans months/years when needed)
export const dateRange = (dates) => {
  const ds = dates.filter(Boolean).map((d) => new Date(d)).sort((a, b) => a - b);
  if (!ds.length) return "";
  const a = ds[0], b = ds[ds.length - 1];
  const full = (d) => `${LONG_MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
  if (dateKey(a.toISOString()) === dateKey(b.toISOString())) return full(a);
  if (a.getFullYear() !== b.getFullYear()) return `${full(a)} - ${full(b)}`;
  if (a.getMonth() !== b.getMonth()) return `${LONG_MONTHS[a.getMonth()]} ${a.getDate()} - ${full(b)}`;
  return `${LONG_MONTHS[a.getMonth()]} ${a.getDate()} - ${b.getDate()}, ${b.getFullYear()}`;
};

// TV-style minute: 90+3'
export const eventMinute = (e) => (e.extra ? `${e.elapsed}+${e.extra}'` : `${e.minute}'`);

const longDate = (iso) => {
  try {
    return new Date(iso).toLocaleString("en-GB", { weekday: "short", day: "numeric", month: "long", hour: "numeric", minute: "2-digit" });
  } catch { return ""; }
};

// Human text for a postponed / moved game (feed notices + bell)
export const scheduleChangeText = (c) => {
  if (c.type === "postponed") return `${c.title} has been postponed. New date to be confirmed.`;
  if (c.type === "cancelled") return `${c.title} has been cancelled.`;
  if (c.type === "rescheduled") return `${c.title} has a new date: ${longDate(c.new_date || c.utcDate)}.`;
  return `${c.title} has moved to ${longDate(c.new_date || c.utcDate)}.`;
};

export const statusLabel = (m) => {
  if (m.status === "PAUSED") return "HT";
  if (isLive(m.status)) return m.elapsed ? `${m.elapsed}'` : "LIVE";
  if (isFinished(m.status)) return "FT";
  if (OFF_LABEL[m.status]) return OFF_LABEL[m.status];
  // kicked off but no update reached us yet (data feed paused)
  if (["TIMED", "SCHEDULED"].includes(m.status) && new Date(m.utcDate) < Date.now() - 10 * 60e3) return "AWAITING";
  return matchTime(m.utcDate);
};

export const timeAgo = (h) => {
  if (h < 1) return "just now";
  if (h < 24) return `${h} ${h === 1 ? "Hour" : "Hours"} ago`;
  const d = Math.floor(h / 24);
  return `${d} ${d === 1 ? "Day" : "Days"} ago`;
};
